var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"star-rating"},[_c('div',{staticClass:"star-rating__row flex--row-center-center"},_vm._l(([1, 2, 3, 4, 5]),function(entry){return _c('Star',{key:entry,class:{
        'star-rating--filled':
          _vm.starFillPercent(entry) == 100 && _vm.rating != null,
        'star-rating--unfilled': _vm.rating == null
      },style:(_vm.colourVar),attrs:{"colour":_vm.colour,"percentageFill":_vm.starFillPercent(entry),"uniqueId":`${_vm.uniqueId}${entry}`}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }